// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReceiptDocumentFileDto
 */
export interface IReceiptDocumentFileDto {
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileDto
     */
    file_id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof IReceiptDocumentFileDto
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileDto
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReceiptDocumentFileDto
     */
    receipt_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileDto
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileDto
     */
    file_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileDto
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IReceiptDocumentFileDto
     */
    provider_name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IReceiptDocumentFileDto
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the IReceiptDocumentFileDto interface.
 */
export function instanceOfIReceiptDocumentFileDto(value: object): value is IReceiptDocumentFileDto {
    return true;
}

export function IReceiptDocumentFileDtoFromJSON(json: any): IReceiptDocumentFileDto {
    return IReceiptDocumentFileDtoFromJSONTyped(json, false);
}

export function IReceiptDocumentFileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReceiptDocumentFileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'claim_ids': json['claim_ids'] == null ? undefined : json['claim_ids'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        'file_path': json['file_path'] == null ? undefined : json['file_path'],
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IReceiptDocumentFileDtoToJSON(json: any): IReceiptDocumentFileDto {
    return IReceiptDocumentFileDtoToJSONTyped(json, false);
}

export function IReceiptDocumentFileDtoToJSONTyped(value?: IReceiptDocumentFileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'file_id': value['file_id'],
        'claim_ids': value['claim_ids'],
        'document_id': value['document_id'],
        'receipt_id': value['receipt_id'],
        'filename': value['filename'],
        'file_path': value['file_path'],
        'file_url': value['file_url'],
        'provider_name': value['provider_name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

